import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	ruleVerbalForm: {
		id: 'eoc.escalation-policies.rule.verbal-form.no-translate',
		defaultMessage: `
    {type, select,
      schedule {
        {notifyType, select,
          default {On call users in }
          next {Next user in }
          previous {Previous user in}
          other {}
        }
      }
      team {
        {notifyType, select,
          all {All members of }
          users {Users of}
          admins {Admins of}
          default {Routed target of }
          random {Random member of }
          other {}
        }
      }
      user {
        Notify
      }
      other {}
    }
    <responder></responder>
    <strong>,</strong>
    {
        notifyCondition, select,
        ifnotacked {if not acknowledged}
        ifnotclosed {if not closed}
        other {}
    }
    `,
		description:
			'Full message of escalation rule. Example: All members of <responder></responder>, if not acknowledged',
	},
	minuteAbbreviation: {
		id: 'eoc.escalation-policies.rule.minute-abbreviation.no-translate',
		defaultMessage: '{time} <span>m</span>',
		description: 'Abbreviation of the minute.',
	},
	deletedEntitytooltip: {
		id: 'eoc.escalation-policies.rule.deleted-entity-tooltip.no-translate',
		defaultMessage: 'This {type} has been deleted, update with another {type}',
		description: 'The tooltip text that informs user about deleted entity',
	},
	infoLabel: {
		id: 'eoc.escalation-policies.rule.deleted-entity.info-label.no-translate',
		defaultMessage: 'Deleted Entity Info',
		description: 'The label of info icon for deleted entity',
	},
});

export default messages;
